import type { PresentationIsEmptyProps } from '../..'

export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  if (!fields.leftImage && !fields.rightImage) {
    return true
  }

  return false
}
